var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-card",
    { staticClass: "chart-card", attrs: { shadow: "hover" } },
    [
      _c("base-echart", {
        attrs: { options: _vm.chartOption, height: "273px" },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }